import React from "react";

export const NoopLayout: React.FC = ({ children }) => <>{children}</>;
